import React, { useState, useEffect } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import 'moment/locale/ru';
import { isAfter } from 'date-fns';
import {
  Card, Space, Typography, DatePicker,
} from 'antd';
import QuestionSelection from './QuestionSelection';

function Params({ params, activeSection }) {
  const { settings, setSettings } = params;
  const [isMobile, setIsMobile] = useState(false);

  const [startDate, setStartDate] = useState(moment().startOf('month'));
  const [endDate, setEndDate] = useState(moment().endOf('day'));

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 1350);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const handleDataChange = ({ sDate, eDate }) => {
    const defaultStartDate = startDate;
    const defaultEndDate = endDate;
    const newStartDate = sDate || defaultStartDate.toDate();
    let newEndDate = eDate || defaultEndDate.toDate();

    newEndDate = isAfter(newStartDate, newEndDate) ? newStartDate : newEndDate;
    const dateFormat = 'DD.MM.YYYY HH:mm';
    // Picker без времени возвращает полночь. Нормализуем диапазон так,
    // чтобы start был 00:00, а end — 23:59 выбранного дня — иначе
    // отчёты теряют записи за последний день (а на single-day выборке
    // возвращают пустоту).
    const time = moment(newStartDate).startOf('day');
    const endTime = moment(newEndDate).endOf('day');

    setStartDate(time);
    setEndDate(endTime);
    setSettings({
      ...settings,
      startDate: time.format(dateFormat),
      endDate: endTime.format(dateFormat),
    });
  };

  const handleQuestionChange = (qId) => {
    setSettings({
      ...settings,
      questId: qId,
    });
  };

  return (
    <Card style={{ margin: isMobile ? '0 0' : '0' }}>
      <Typography.Title level={4}>Параметры</Typography.Title>
      <Space direction="horizontal" size="middle" align="center">
        <DatePicker.RangePicker
          value={[moment(startDate), moment(endDate)]}
          format="DD.MM.YYYY"
          onCalendarChange={([sDate, eDate]) => handleDataChange({ sDate, eDate })}
        />
        {activeSection === 'nps'
          ? (<QuestionSelection handleQuestionChange={handleQuestionChange} />) : null}
      </Space>
    </Card>
  );
}

export default Params;
